import * as React from 'react'
import { SVGProps } from 'react'
const SvgAverageZero = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 129 129' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <circle cx={64.699} cy={64.294} r={64} fill='#EEE' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m23.023 75.978 17.05-26.213c1.423-2.188 4.637-2.16 6.022.051l6.216 9.924 14.183-20.63V18.62c0-.789.64-1.429 1.43-1.429h.203c.79 0 1.43.64 1.43 1.43v.988h13.882c.789 0 1.429.64 1.429 1.429v10.52c0 .788-.64 1.428-1.43 1.428H70.363v6.124l16.923 24.82c-2.095-1.45-7.091-3.287-10.315.968-2.707 5.286-7.467 13.27-9.509 16.6H26.018c-2.835 0-4.54-3.144-2.995-5.52Zm56.991-6.361-16.776 27.99c-1.142 1.905.23 4.327 2.452 4.327h33.187c2.208 0 3.582-2.398 2.465-4.303l-16.411-27.99c-1.098-1.873-3.8-1.886-4.917-.024Zm3.81 10.094h-3.137a.715.715 0 0 0-.715.714v8.709c0 .094.019.187.055.274l.487 1.168c.11.266.37.44.66.44h2.32c.318 0 .598-.21.686-.515l.33-1.127a.713.713 0 0 0 .028-.2v-8.749a.715.715 0 0 0-.715-.714Zm.714 15.416a2.283 2.283 0 1 1-4.566 0 2.283 2.283 0 0 1 4.566 0Z'
      fill='#7A7A7C'
    />
  </svg>
)
export default SvgAverageZero
